var React = require('react');

function Titan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Titan"),React.createElement("g",{"id":"g1413","key":2},[React.createElement("path",{"id":"path875-5","className":"cls-1","d":"M24,73.56l32-32H72l32,32v-24l-40-40-40,40Z","key":0}),React.createElement("path",{"id":"path875-5-6","className":"cls-1","d":"M24,121.56l32-32H72l32,32v-24l-32-32H56l-32,32Z","key":1})])]);
}

Titan.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Titan;

Titan.default = Titan;
